import classNames from 'classnames';
import { Eye, EyeOff } from 'react-feather';
import { useTranslation } from 'react-i18next';

import { useMutation } from '../../../Shared/api';
import { useNotifier } from '../../../Shared/Notifier/NotificationProvider';
import { Toggle } from '../../../Shared/UI/Toggle';
import { useRouter } from '../../router';
import { Product } from '../../types';

export default function ProductToggle({
  product,
}: {
  product: Product;
}) {
  const { t } = useTranslation();
  const { routes } = useRouter();
  const notifier = useNotifier();

  const [toggleProduct, { loading }] = useMutation(routes.toggle_product(product.id), {
    preserveScroll: true,
    onSuccess: () => {
      notifier.notify(
        !product.enabled ? t('backend:product_enabled') : t('backend:product_disabled'),
        !product.enabled ? Eye : EyeOff
      );
    },
  });

  return (
    <div className="inline-flex items-center space-x-4">
      <div className={classNames('font-medium', product.enabled ? 'text-emerald-600' : 'text-slate-500')}>
        {product.enabled ? t('backend:live') : t('backend:offline')}
      </div>
      <div className="z-20">
        <Toggle
          checked={product.enabled}
          onChange={() => toggleProduct({ enabled: !product.enabled })}
          disabled={loading}
          aria-label={t(product.enabled ? 'backend:disable_name' : 'backend:enable_name', { name: product.title })}
        />
      </div>
    </div>
  );
}
